import React, { FC } from 'react'
import './Core.css'
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner'

interface LoadingScreenProps {
  children?: React.ReactNode
  width?: number
  height?: number
}

export const LoadingScreen: FC<LoadingScreenProps> = ({ children, width, height }) => {
  return (
    <div
      className="pdf-ocg-core__loading-container"
      style={{
        width: width ? `${width}px` : undefined,
        height: height ? `${height}px` : undefined,
      }}
    >
      <LoadingSpinner>{children && children}</LoadingSpinner>
    </div>
  )
}
